import { render, staticRenderFns } from "./RelationQuesBar.vue?vue&type=template&id=1c06c508&scoped=true&"
import script from "./RelationQuesBar.vue?vue&type=script&lang=js&"
export * from "./RelationQuesBar.vue?vue&type=script&lang=js&"
import style0 from "./RelationQuesBar.vue?vue&type=style&index=0&id=1c06c508&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c06c508",
  null
  
)

export default component.exports